import React from 'react';
import { FaUserPlus, FaCrown, FaDollarSign, FaCalendarAlt } from 'react-icons/fa';

const DailyStats = ({ 
  dailyNewUsers, 
  dailyNewSubscribers, 
  dailySubscriptionAmount, 
  monthlySubscriptionAmount 
}) => {
  // Helper function to check if a value is in loading state
  const isLoading = (value) => {
    return typeof value === 'string' && value === 'Loading...';
  };

  return (
    <div className="stats-card daily-stats">
      <h2>Daily Metrics</h2>
      <div className="stats-grid">
        <div className="stat-item">
          <div className="stat-icon">
            <FaUserPlus />
          </div>
          <div className="stat-content">
            <h3>New Users Today</h3>
            <p className={`stat-value ${isLoading(dailyNewUsers) ? 'loading' : ''}`}>
              {isLoading(dailyNewUsers) ? '0' : dailyNewUsers}
            </p>
            {isLoading(dailyNewUsers) && <small className="stat-loading-text">Loading...</small>}
          </div>
        </div>

        <div className="stat-item">
          <div className="stat-icon">
            <FaCrown />
          </div>
          <div className="stat-content">
            <h3>New Subscribers Today</h3>
            <p className={`stat-value ${isLoading(dailyNewSubscribers) ? 'loading' : ''}`}>
              {isLoading(dailyNewSubscribers) ? '0' : dailyNewSubscribers}
            </p>
            {isLoading(dailyNewSubscribers) && <small className="stat-loading-text">Loading...</small>}
          </div>
        </div>

        <div className="stat-item">
          <div className="stat-icon">
            <FaDollarSign />
          </div>
          <div className="stat-content">
            <h3>Today's Revenue</h3>
            <p className={`stat-value ${isLoading(dailySubscriptionAmount) ? 'loading' : ''}`}>
              {isLoading(dailySubscriptionAmount) ? '$0.00' : `$${dailySubscriptionAmount}`}
            </p>
            {isLoading(dailySubscriptionAmount) && <small className="stat-loading-text">Loading...</small>}
          </div>
        </div>

        <div className="stat-item">
          <div className="stat-icon">
            <FaCalendarAlt />
          </div>
          <div className="stat-content">
            <h3>Monthly Revenue</h3>
            <p className={`stat-value ${isLoading(monthlySubscriptionAmount) ? 'loading' : ''}`}>
              {isLoading(monthlySubscriptionAmount) ? '$0.00' : `$${monthlySubscriptionAmount}`}
            </p>
            {isLoading(monthlySubscriptionAmount) && <small className="stat-loading-text">Loading...</small>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailyStats;